import React from 'react';
import { withStyles,
  FormControl,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, 
  InputLabel,
  Select,
  MenuItem,
  InputAdornment} from '@material-ui/core';
import { parse, format, isBefore } from 'date-fns';
import Utils from '../../share/Utils';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 290,
  },
  flex: {
    display: 'flex',
  },
  textFieldDe: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 1,
    width: 180,
  },
  textFieldAte: {
    marginLeft: theme.spacing.unit * 1,
    marginRight: theme.spacing.unit * 1,
    width: 200,
  },
  selectCodigo: {
    margin: theme.spacing.unit * -0.1,
    width: 120,
    marginLeft: theme.spacing.unit,
  },
  formControlValor: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    width: 200,
  },
});
class FormDialogVigenciaPorte extends React.Component {
  utils = new Utils();
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.vigencia,
      errorMessageValor: '',
      errorMessageDataInicio: '',
      errorMessageDataFim: '',
    };
    this.state.valPorte = this.state.valPorte === undefined ? '' : this.state.valPorte;
    this.state.dtaInicio = format(parse(this.state.dtaInicio), 'YYYY-MM-DD');
    this.state.dtaFim = this.state.dtaFim === null ? '' : format(parse(this.state.dtaFim), 'YYYY-MM-DD');
    this.state.codPorteAnestesico = this.state.codPorteAnestesico === null || this.state.codPorteAnestesico === undefined ? '' : this.state.codPorteAnestesico;
  }
  handleBlurValor = event => {
    if (this.state.valPorte === '' || this.state.valPorte === null || this.state.valPorte === undefined) {
      this.setState({errorMessageValor: 'Favor preencher o valor'});
    }
  }
  handleBlurDataInicio = event => {
    if (this.state.dtaInicio === null ||
      this.state.dtaInicio === undefined ||
      this.state.dtaInicio === '') {
      this.setState({errorMessageDataInicio: 'Este campo é obrigatório'});
    } else {
      this.setState({errorMessageDataInicio: ''});
    }
  }
  handleBlurDataFinal = event => {
    if (this.state.dtaFim === null ||
      this.state.dtaFim === undefined ||
      this.state.dtaFim === '') {
      this.setState({errorMessageDataFinal: ''});
    } else {
      if (isBefore(parse(this.state.dtaFim), parse(this.state.dtaInicio))){
        this.setState({errorMessageDataFim: 'Data menor que data início'});
      } else {
        this.setState({errorMessageDataFim: ''});
      }
    }
  }
  handleChangeTextField = event => {
    var valorNovo = event.target.value !== '' ? this.utils.formataValor(event.target.value, event.target.defaultValue) : '';
    this.setState({ [event.target.name]: valorNovo, errorMessageValor: '' });
  };

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleClickSave = async () => {
    const vigencia = {
      codVigencia: this.state.codVigencia,
      codPorteAnestesico: this.state.codPorteAnestesico,
      valPorte: this.state.valPorte.replace('.', '').replace(',', '.'),
      dtaInicio: this.state.dtaInicio,
      dtaFim: this.state.dtaFim === '' || this.state.dtaFim === undefined || this.state.dtaFim === 'Invalid Date' ? null : this.state.dtaFim,
      dtaCancelamento: null,
      txtMotivoCancelamento: '',
    };
    await this.props.handleSave(vigencia);
  }

  isSalvarDisabled = () => {
    return (this.state.errorMessageDataInicio !== '' ||
    this.state.dtaInicio === undefined ||
    this.state.dtaInicio === '' ||
    this.state.dtaInicio === 0) ||

    (this.state.errorMessageDataFim !== '') ||

    (this.state.codPorteAnestesico === '') ||
    
    (this.state.errorMessageValor !== '' ||
    this.state.valPorte === undefined ||
    this.state.valPorte === 0 ||
    this.state.valPorte === '');
  }
  render () {
    const { classes, open, handleClose, titulo } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='sm'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>{titulo}</DialogTitle>
          <DialogContent>
          <FormControl>
                <InputLabel shrink htmlFor='tipo-simple' className={classes.selectCodigo}>
                  Código do Porte
                </InputLabel>
                <Select
                  disabled={!this.props.isEditavel}
                  className={classes.selectCodigo}
                  value={this.state.codPorteAnestesico === null || this.state.codPorteAnestesico === undefined ? 0 : this.state.codPorteAnestesico}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'codPorteAnestesico',
                  }}
                >
                  {this.props.portes.map((porte, idx) => {
                    return (<MenuItem key={idx} value={porte.id}>{porte.nome}</MenuItem>);
                  })}
                </Select>
              </FormControl>
              <FormControl>
              <TextField
                id='date'
                label={this.state.errorMessageDataInicio !== '' ? this.state.errorMessageDataInicio : 'Data Início'}
                type='date'
                value={this.state.dtaInicio}
                onBlur={this.handleBlurDataInicio}
                onChange={this.handleChange}
                error={this.state.errorMessageDataInicio !== ''}
                inputProps={{
                  name: 'dtaInicio',
                }}
                className={classes.textFieldDe}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormControl>
            <FormControl>
              <TextField
                id='date'
                label={this.state.errorMessageDataFim !== '' ? this.state.errorMessageDataFim : 'Data Fim'}
                className={classes.textFieldAte}
                type='date'
                value={this.state.dtaFim}
                onBlur={this.handleBlurDataFinal}
                error={this.state.errorMessageDataFim !== ''}
                onChange={this.handleChange}
                inputProps={{
                  name: 'dtaFim',
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormControl>
            <FormControl className={classes.formControlValor}>
                <TextField
                  value={this.state.valPorte === null ? '0,00' : this.utils.formataValor(this.state.valPorte)}
                  disabled={!this.props.isEditavel}
                  margin='dense'
                  id='valPorte'
                  name='valPorte'
                  error={this.state.errorMessageValor !== ''}
                  label={this.state.errorMessageValor !== '' ? this.state.errorMessageValor : 'Valor'}
                  fullWidth
                  onChange={this.handleChangeTextField}
                  onBlur={this.handleBlurValor}
                  InputProps={{
                    startAdornment: <InputAdornment position='start'>R$</InputAdornment>
                  }}
                />
              </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled()}
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogVigenciaPorte);
